import __base_store from '@/store/__base_store'

/**
 * Store de provincias.
 */
export default __base_store({
	state: {
		model_name: 'provincia',
	},
})

